import React from 'react';
import './aboutus.css';
import { Link } from 'react-router-dom';

function AboutUs() {
  return (
    <section className="about-us">





     {/* Hero Section */}
<div className="about-hero">
  <div className="hero-content">
    <div className="hero-text">
      <h1 className="hero-title">
        Your Journey to <span className="highlight">Rich Experiences</span>
      </h1>
      <p className="hero-subtitle">
        Premium travel services that transform ordinary trips into extraordinary memories
      </p>
      <div className="hero-stats-about">
        <div className="stat-about">
          <span className="stat-number-about">10K+</span>
          <span className="stat-label-about">Satisfied Travelers</span>
        </div>
        <div className="stat-about">
          <span className="stat-number-about">50+</span>
          <span className="stat-label-about">Destinations</span>
        </div>
        <div className="stat-about">
          <span className="stat-number-about">24/7</span>
          <span className="stat-label-about">Luxury Service</span>
        </div>
              <div className="stat-about">
          <span className="stat-number-about">25</span>
          <span className="stat-label-about">Districts Covered</span>
        </div>
      </div>
    </div>

    <div className="hero-image-about">
      <img 
        src='/fleetimg4.png' 
        alt="Premium travel fleet"
      />
    </div>
  </div>
</div>




      {/* Mission & Vision Section */}
      <div className="mission-vision">
        <div className="container">
          <div className="mission-grid">
            <div className="mission-card">
              <div className="card-header">
                <div className="icon-wrapper">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
                </div>
                <h3>Our Mission</h3>
              </div>
              <p>
                To deliver exceptional travel experiences that exceed expectations, 
                providing personalized service, comfort, and reliability for every journey. 
                We turn travel dreams into cherished realities.
              </p>
            </div>
            
            <div className="mission-card">
              <div className="card-header">
                <div className="icon-wrapper">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5.5-2.5l7.51-3.49L17.5 6.5 9.99 9.99 6.5 17.5zm5.5-6.6c.61 0 1.1.49 1.1 1.1s-.49 1.1-1.1 1.1-1.1-.49-1.1-1.1.49-1.1 1.1-1.1z"/>
                  </svg>
                </div>
                <h3>Our Vision</h3>
              </div>
              <p>
                To be the most trusted name in premium travel, renowned for our 
                unwavering commitment to quality, personalized service, and creating 
                unforgettable experiences for every client.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Story Section */}
      <div className="our-story">
        <div className="container">
          <div className="story-grid">
            <div className="story-content">
              <h2>Our Story</h2>
              <div className="story-text">
                <p>
                  Established in 2021, Eco Rich Travels was born from a passion for 
                  creating extraordinary travel experiences. What began as a boutique 
                  service for luxury getaways has evolved into a comprehensive travel 
                  company serving discerning clients worldwide.
                </p>
                <p>
                  Our name reflects our commitment to providing 'rich' experiences - 
                  not just in luxury, but in cultural immersion, personal growth, and 
                  creating lasting memories. We believe every journey should be transformative.
                </p>
              </div>
              <div className="story-features">
                <div className="feature">
                  <div className="feature-dot"></div>
                  <span>Personalized Itineraries</span>
                </div>
                <div className="feature">
                  <div className="feature-dot"></div>
                  <span>Luxury Accommodations</span>
                </div>
                <div className="feature">
                  <div className="feature-dot"></div>
                  <span>Expert Local Guides</span>
                </div>
              </div>
            </div>
            <div className="story-visual">

<div className="timeline">
  <div className="timeline-item">
    <div className="timeline-year">2021</div>
    <div className="timeline-content">
      <h4>Heritage Tours Begin</h4>
      <p>Started cultural tours in Cultural Triangle</p>
    </div>
  </div>
  <div className="timeline-item">
    <div className="timeline-year">2021</div>
    <div className="timeline-content">
      <h4>Coastal Expansion</h4>
      <p>Added beach and southern coast tours</p>
    </div>
  </div>
  <div className="timeline-item">
    <div className="timeline-year">2022</div>
    <div className="timeline-content">
      <h4>Hill Country Services</h4>
      <p>Launched luxury tours to tea country</p>
    </div>
  </div>



  <div className="timeline-item">
    <div className="timeline-year">2023</div>
    <div className="timeline-content">
      <h4>Island-Wide Expansion</h4>
      <p>Expanded services across Sri Lanka</p>
    </div>
  </div>


  <div className="timeline-item">
    <div className="timeline-year">2023</div>
    <div className="timeline-content">
      <h4>Premium Services Launch</h4>
      <p>Introduced VIP luxury travel packages</p>
    </div>
  </div>

  </div>


            </div>
          </div>
        </div>
      </div>

      {/* Values Section */}
      <div className="our-values">
        <div className="container">
          <div className="section-header">
            <h2>Our Values</h2>
            <p>The principles that make every journey exceptional</p>
          </div>
          <div className="values-grid">
            <div className="value-card">
              <h4>Excellence</h4>
              <p>Uncompromising quality in every service we provide, from planning to execution.</p>
            </div>
            <div className="value-card">
              <h4>Personalization</h4>
              <p>Tailoring every journey to match your unique preferences and travel style.</p>
            </div>
            <div className="value-card">
              <h4>Reliability</h4>
              <p>Consistent, dependable service that you can trust for your most important travels.</p>
            </div>
            {/* <div className="value-card">
              <h4>Luxury</h4>
              <p>Curating premium experiences that redefine comfort and sophistication.</p>
            </div> */}
          </div>
        </div>
      </div>

      {/* Team Section */}
      <div className="leadership-team">
        <div className="container">
          <div className="section-header">
            <h2>Leadership Team</h2>
            <p>Meet the experts crafting your unforgettable journeys</p>
          </div>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-photo">
                <div className="photo-placeholder">
  <img 
    src='/nilanka.png' 
    style={{
      height: '140px',
      width: '140px',
      borderRadius: '50%',
      objectFit: 'cover',
      border: '3px solid white',
      boxShadow: '0 8px 25px rgba(0, 0, 0, 0.2)',
      display: 'block',
      margin: '0 auto'
    }} 
  />
</div>
              </div>
              <h4>Nilanka Dias</h4>
              <p className="member-role">CEO & Founder</p>
              <p className="member-bio">
                6+ years in luxury travel industry, passionate about creating unique experiences.
              </p>
            </div>
            <div className="team-member">
              <div className="member-photo">
                <div className="photo-placeholder">  <img 
    src='/melda.png' 
    style={{
      height: '140px',
      width: '140px',
      borderRadius: '50%',
      objectFit: 'cover',
      border: '3px solid white',
      boxShadow: '0 8px 25px rgba(0, 0, 0, 0.2)',
      display: 'block',
      margin: '0 auto'
    }} 
  /></div>
              </div>
              <h4>Melda Gomez</h4>
              <p className="member-role">Head of Operations</p>
              <p className="member-bio">
                Operations expert ensuring seamless travel experiences worldwide.
              </p>
            </div>
            <div className="team-member">
              <div className="member-photo">
                <div className="photo-placeholder">
              <img 
                  src='/chalaka.png' 
                  style={{
                    height: '140px',
                    width: '140px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: '3px solid white',
                    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.2)',
                    display: 'block',
                    margin: '0 auto'
                  }} 
                />

                </div>
              </div>
              <h4>Chalaka Amarasinghe</h4>
             <p className="member-role">Lead Driver</p>
              <p className="member-bio">
                Ensuring safe, comfortable, and punctual transportation with expert knowledge of local routes and destinations.
              </p>
            
            </div>
          </div>
        </div>
      </div>


      {/* CTA Section */}
      <div className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready for Your Next Adventure?</h2>
            <p>Let us craft your perfect journey filled with rich experiences and lasting memories</p>
            <div className="cta-buttons">
              <Link to="/bookings">
              <button className="btn-primary">Plan Your Trip</button>
              </Link>

              {/* <button className="btn-secondary">View Destinations</button> */}
              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;